import { TextField, TextFieldProps } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

import classes from './Input.module.scss';

export type InputProps = Omit<TextFieldProps, 'variant'> & {
    error?: boolean;
    className?: string;
};

export const Input = React.forwardRef<HTMLInputElement | HTMLDivElement, InputProps>(
    ({ error, label, ...props }, ref) => {
        return (
            <div
                className={clsx(classes.root, props.className, {
                    [classes.multiline]: props.multiline
                })}
            >
                {props.multiline && label && (
                    <label className={classes.label}>
                        {label}
                        {props.required && <span className={classes.asterisk}>*</span>}
                    </label>
                )}

                <TextField
                    variant="outlined"
                    {...props}
                    ref={ref}
                    label={props.multiline ? undefined : label}
                    className={clsx(classes.input, {
                        [classes.error]: error
                    })}
                />
            </div>
        );
    }
);

Input.displayName = 'Input';
